"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialogBase = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var Button_1 = require("../Button");
var LoadingSpinner_1 = require("../LoadingSpinner");
var DialogBase_1 = require("./DialogBase");
var Bubble_1 = require("../Bubble");
var Typography_1 = require("../Typography");
/**
 * @internal
 */
var ConfirmDialogBase = /** @class */ (function (_super) {
    tslib_1.__extends(ConfirmDialogBase, _super);
    function ConfirmDialogBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfirmDialogBase.prototype.render = function () {
        var _a = this.props, isPositive = _a.isPositive, displayCloseButton = _a.displayCloseButton, headline = _a.headline, warning = _a.warning, children = _a.children, cancelButtonText = _a.cancelButtonText, submitButtonText = _a.submitButtonText, submitButtonTooltipText = _a.submitButtonTooltipText, submitButtonTooltipAlignPoints = _a.submitButtonTooltipAlignPoints, submitButtonTooltipArrowOffsets = _a.submitButtonTooltipArrowOffsets, isSubmitDisabled = _a.isSubmitDisabled, showProgressIndicator = _a.showProgressIndicator, onSubmit = _a.onSubmit, onCancel = _a.onCancel, headerLeftButtonRenderer = _a.headerLeftButtonRenderer, footerLeftRenderer = _a.footerLeftRenderer, titleRightIconRenderer = _a.titleRightIconRenderer, dialogHeaderClassName = _a.dialogHeaderClassName;
        var dialogClasses = classnames_1.default({
            "gd-confirm": true,
        }, this.getDialogClasses());
        var submitButtonClasses = classnames_1.default({
            "s-dialog-submit-button": true,
            "gd-button-action": isPositive,
            "gd-button-negative": !isPositive,
        });
        var headerClassNames = classnames_1.default("gd-dialog-header", dialogHeaderClassName);
        return (react_1.default.createElement("div", { tabIndex: 0, onKeyDown: this.onKeyDown },
            react_1.default.createElement("div", { className: dialogClasses },
                displayCloseButton ? this.renderCloseButton() : null,
                react_1.default.createElement("div", { className: "gd-dialog-header-wrapper" }, headerLeftButtonRenderer === null || headerLeftButtonRenderer === void 0 ? void 0 :
                    headerLeftButtonRenderer(),
                    react_1.default.createElement("div", { className: headerClassNames },
                        react_1.default.createElement(Typography_1.Typography, { tagName: "h3", className: "gd-dialog-header-title" }, headline), titleRightIconRenderer === null || titleRightIconRenderer === void 0 ? void 0 :
                        titleRightIconRenderer())),
                !!warning && react_1.default.createElement("div", { className: "gd-dialog-warning" }, warning),
                react_1.default.createElement("div", { className: "gd-dialog-content" }, children),
                react_1.default.createElement("div", { className: "gd-dialog-footer" }, footerLeftRenderer === null || footerLeftRenderer === void 0 ? void 0 :
                    footerLeftRenderer(),
                    showProgressIndicator ? (react_1.default.createElement(LoadingSpinner_1.LoadingSpinner, { className: "gd-dialog-spinner small" })) : null,
                    react_1.default.createElement(Button_1.Button, { onClick: onCancel, className: "gd-button-secondary s-dialog-cancel-button", value: cancelButtonText }),
                    submitButtonText ? (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { className: "gd-button", showDelay: 0, hideDelay: 0 },
                        react_1.default.createElement(Button_1.Button, { onClick: onSubmit, className: submitButtonClasses, value: submitButtonText, disabled: isSubmitDisabled }),
                        submitButtonTooltipText ? (react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", alignPoints: submitButtonTooltipAlignPoints || [{ align: "bc tc" }], arrowOffsets: submitButtonTooltipArrowOffsets || { "bc tc": [0, 15] } }, submitButtonTooltipText)) : null)) : null))));
    };
    ConfirmDialogBase.defaultProps = {
        displayCloseButton: true,
        onCancel: noop_1.default,
        onSubmit: noop_1.default,
        isSubmitDisabled: false,
        headerLeftButtonRenderer: undefined,
    };
    return ConfirmDialogBase;
}(DialogBase_1.DialogBase));
exports.ConfirmDialogBase = ConfirmDialogBase;
//# sourceMappingURL=ConfirmDialogBase.js.map